export const getTokensFromCookies = () => {
  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find(cookie => cookie.trim().startsWith(`st-${process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID}`));

  if (!tokenCookie) {
    throw new Error('Access token cookie not found');
  }

  const cookieValue = decodeURIComponent(tokenCookie.split('=')[1]);
  const tokenData = JSON.parse(cookieValue);

  return {
    accessToken: tokenData['access_token'],
    refreshToken: tokenData['refresh_token'],
  };
}; 
